/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step2_NameInputs */

const en_dr_step2_name = /** @type {(inputs: Dr_Step2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 · Users`)
};

const id_dr_step2_name = /** @type {(inputs: Dr_Step2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 · Pengguna`)
};

/**
* | output |
* | --- |
* | "2 · Users" |
*
* @param {Dr_Step2_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step2_name = /** @type {((inputs?: Dr_Step2_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step2_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step2_name(inputs)
	return en_dr_step2_name(inputs)
});